(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["madera-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('madera-review-carousel')) {
    class MaderaReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.madera-reviews__track');
        this.dotsWrap = this.querySelector('.madera-reviews__dots');
        if (!this.track || !this.dotsWrap) return;

        this.teardown();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayDelay = Number(this.dataset.autoplay) || 0;
        this.paused = false;
        this.dots = [];

        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { signal, passive: true });

        this.dotsWrap.addEventListener('click', (event) => {
          const dot = event.target.closest('.madera-reviews__dot');
          if (!dot) return;
          this.go(Number(dot.dataset.index));
          this.restartAutoplay();
        }, { signal });

        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.restartAutoplay();
        }, { signal });

        // Theme editor: porta in vista la recensione selezionata nella sidebar
        this.addEventListener('shopify:block:select', (event) => {
          const slide = this.slides.find((el) => el.contains(event.target));
          if (!slide) return;
          this.pauseAutoplay(true);
          this.refresh();
          this.go(this.slides.indexOf(slide), true);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => this.pauseAutoplay(false), { signal });

        // Autoplay: pausa su hover, focus, touch e tab non visibile
        const pause = () => this.pauseAutoplay(true);
        const resume = () => this.pauseAutoplay(false);
        this.addEventListener('pointerenter', pause, { signal });
        this.addEventListener('pointerleave', resume, { signal });
        this.addEventListener('focusin', pause, { signal });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) resume(); }, { signal });
        this.track.addEventListener('touchstart', pause, { signal, passive: true });
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stopAutoplay() : this.restartAutoplay()), { signal });

        this.mutationObserver = new MutationObserver(() => this.refresh());
        this.mutationObserver.observe(this.track, { childList: true });
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);

        this.refresh();
        this.restartAutoplay();
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        this.controller?.abort();
        this.mutationObserver?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.stopAutoplay();
      }

      refresh() {
        this.slides = Array.from(this.track.children).filter((el) => !['SCRIPT', 'STYLE', 'TEMPLATE', 'LINK'].includes(el.tagName));
        const total = this.slides.length;
        const designMode = Boolean(window.Shopify && window.Shopify.designMode);

        // Nell'editor non nascondere mai il blocco, altrimenti non si possono aggiungere recensioni
        this.hidden = total === 0 && !designMode;

        this.slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'recensione');
          slide.setAttribute('aria-label', (i + 1) + ' di ' + total);
        });

        // Ricrea i puntini solo se il numero di recensioni è cambiato
        if (this.dots.length !== total) {
          this.dotsWrap.replaceChildren();
          this.dots = this.slides.map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'madera-reviews__dot';
            dot.dataset.index = i;
            dot.setAttribute('aria-label', 'Recensione ' + (i + 1) + ' di ' + total);
            dot.appendChild(document.createElement('span'));
            this.dotsWrap.appendChild(dot);
            return dot;
          });
        }
        this.classList.toggle('has-dots', total > 1);

        this.index = -1;
        this.update();
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      currentIndex() {
        const left = this.track.getBoundingClientRect().left;
        let best = 0;
        let distance = Infinity;
        this.slides.forEach((slide, i) => {
          const d = Math.abs(slide.getBoundingClientRect().left - left);
          if (d < distance) { distance = d; best = i; }
        });
        return best;
      }

      update() {
        if (!this.slides?.length) return;
        const index = this.currentIndex();
        if (index === this.index) return; // nessuna scrittura DOM se la slide non cambia
        this.index = index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      }

      go(index, instant = false) {
        const total = this.slides?.length || 0;
        if (!total) return;
        const target = this.slides[Math.max(0, Math.min(index, total - 1))];
        const delta = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({
          left: delta,
          behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth'
        });
      }

      /* ---------- Autoplay ---------- */
      canAutoplay() {
        return this.autoplayDelay > 0
          && !this.reducedMotion.matches
          && (this.slides?.length || 0) > 1
          && !(window.Shopify && window.Shopify.designMode);
      }

      restartAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay() || this.paused || document.hidden) return;
        this.timer = setInterval(() => {
          const last = this.index >= this.slides.length - 1;
          this.go(last ? 0 : this.index + 1);
        }, this.autoplayDelay);
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }

      pauseAutoplay(state) {
        this.paused = state;
        state ? this.stopAutoplay() : this.restartAutoplay();
      }
    }

    customElements.define('madera-review-carousel', MaderaReviews);
  }
  } catch(e) { console.error(e); }
})();

})();
